const MerchantsPage = () => {
  return <div>merchants page</div>;
};

export default MerchantsPage;
